export default __webpack_public_path__ + "static/media/header.c4e7b0ce.jpg";